import React from 'react';
import { motion } from 'framer-motion';
import { BellRingIcon, BookOpenIcon } from 'lucide-react';
export function CtaFinalSection() {
  return <section className="w-full py-24 bg-transparent px-4 overflow-hidden relative" data-id="element-91">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[400px] bg-gradPurple/10 blur-[150px] rounded-full pointer-events-none" data-id="element-92" />

      <div className="max-w-4xl mx-auto flex flex-col items-center text-center relative z-10" data-id="element-93">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="w-full bg-cardBg/90 backdrop-blur-md rounded-3xl p-10 md:p-16 border-2 border-gradPurple/50 shadow-[0_0_50px_rgba(138,43,226,0.4)] flex flex-col items-center relative overflow-visible" data-id="element-94">
          {/* 50% OFF circle */}
          <div className="absolute top-4 right-4 md:top-6 md:right-6 bg-gradient-to-r from-gradOrange to-gradPink text-white font-black text-sm md:text-base w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full shadow-[0_0_20px_rgba(255,107,0,0.4)] rotate-12 border-2 border-white/20 z-20" data-id="element-95">
            50% OFF
          </div>

          <h2 className="text-3xl md:text-5xl font-black leading-tight relative z-10 mb-6 text-white text-center" data-id="element-96">
            Accedé al{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gradPurple to-gradPink" data-id="element-97">
              MegaPack Cursada Sin Estrés
            </span>{' '}
            Completo
          </h2>

          {/* Oval with bell icon */}
          <div className="bg-gradOrange/20 border border-gradOrange px-8 py-3 rounded-full mb-8 relative z-10 flex items-center gap-2 shadow-[0_0_20px_rgba(255,107,0,0.5)]" data-id="element-98">
            <BellRingIcon className="w-5 h-5 text-gradOrange animate-pulse" data-id="element-99" />
            <p className="text-lg md:text-xl text-white font-bold drop-shadow-[0_0_8px_rgba(255,255,255,0.5)]" data-id="element-100">
              Oferta imperdible — Solo por hoy
            </p>
          </div>

          <span className="text-xl md:text-2xl text-textMuted line-through font-bold mb-2 relative z-10" data-id="element-101">
            Antes: $39.999
          </span>

          <span className="text-6xl md:text-8xl font-black text-white tracking-tight mb-4 relative z-10" data-id="element-102">
            $19.999
          </span>

          <p className="text-base md:text-lg text-textMuted font-bold mb-10 relative z-10 flex items-center gap-2" data-id="element-103">
            <BookOpenIcon className="w-5 h-5 text-gradPurple" data-id="element-104" />
            Incluye 5 tomos + 3 bonos 🎁
          </p>

          <a href="https://checkout.infinita-mente.online/checkouts/cn/hWN9hJcYAJ6aX5aJ3wBC1CQj/es-ar?_r=AQAB8bH0zu89K7bsPll58nLRDWhvvq0TO43BcpK3J-clHp8&preview_theme_id=138558668898" target="_blank" rel="noopener noreferrer" className="bg-gradient-to-r from-[#10B981] to-[#047857] hover:from-[#059669] hover:to-[#065f46] text-white font-black text-xl md:text-2xl px-8 py-3 rounded-full shadow-[0_0_15px_rgba(16,185,129,0.3)] transition-all duration-300 hover:scale-105 active:scale-95 w-full md:w-auto inline-block text-center no-underline mb-8 relative z-10 flex flex-col items-center justify-center leading-tight" data-id="element-105">
            <span data-id="element-106">Quiero mi MegaPack</span>
            <span className="text-lg md:text-xl opacity-90" data-id="element-107">ahora</span>
          </a>

          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-6 text-xs md:text-sm font-medium text-textMuted relative z-10" data-id="element-108">
            <span className="flex items-center gap-2" data-id="element-109">
              <span className="text-white/50" data-id="element-110">📄</span> 100% PDF
            </span>
            <span className="flex items-center gap-2" data-id="element-111">
              <span className="text-white/50" data-id="element-112">⚡</span> Acceso inmediato
            </span>
            <span className="flex items-center gap-2" data-id="element-113">
              <span className="text-white/50" data-id="element-114">🛡️</span> Garantía 7 días
            </span>
            <span className="flex items-center gap-2" data-id="element-115">
              <span className="text-white/50" data-id="element-116">💳</span> Mercado Pago
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}